export default __webpack_public_path__ + "static/media/valla.3c0df1aa.png";